/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Valves_Associated_With_GatewayInputs */



/**
* | output |
* | --- |
* | "Th. heads are associated with this gateway" |
*
* @param {Valves_Associated_With_GatewayInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const valves_associated_with_gateway = /** @type {((inputs?: Valves_Associated_With_GatewayInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Valves_Associated_With_GatewayInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Th. heads are associated with this gateway")
	return /** @type {LocalizedString} */ ("Des têtes th. sont associées à cette box")
});